// JATASCH HEADER SCROLL FIX V7
// Voeg dit bestand toe als asset en laad het met defer in theme.liquid.
// Het zet een class op <body> zodra je scrolt, zodat CSS betrouwbaar weet
// wanneer de mobiele header van transparant naar Jatasch-paars moet gaan.

(function () {
  function updateJataschHeaderState() {
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var isScrolled = window.scrollY > 8;

    if (isMobile && isScrolled) {
      document.body.classList.add('jatasch-header-scrolled');
    } else {
      document.body.classList.remove('jatasch-header-scrolled');
    }
  }

  updateJataschHeaderState();

  window.addEventListener('scroll', updateJataschHeaderState, { passive: true });
  window.addEventListener('resize', updateJataschHeaderState);
  window.addEventListener('orientationchange', updateJataschHeaderState);
  document.addEventListener('shopify:section:load', updateJataschHeaderState);
})();
